import React, { Component } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Desplegable from "../../desplegable";

export default class VistaDatosTestamentoHermana extends Component {
  render() {
    const testamentoBienes =
      this.props.DatosMonja.datosTestamento && this.props.DatosMonja.datosTestamento.goodTestament && this.props.DatosMonja.datosTestamento.goodTestament !== "" ? (
        <Col lg="6" className="border">
          <h6>Testamento de Bienes</h6>
          <a href={process.env.REACT_APP_API_URL + "/download/hermanas/" + this.props.DatosMonja.sister.id + "/testamentoBienes"} target="_blank" rel="noreferrer">
            PDF Testamento de Bienes
          </a>
        </Col>
      ) : (
        <Col lg="6" className="border">
          <h6>PDF Testamento de Bienes</h6>
          <p>Testamento no adjuntado</p>
        </Col>
      );

    const testamentoVital =
      this.props.DatosMonja.datosTestamento && this.props.DatosMonja.datosTestamento.vitalTestament && this.props.DatosMonja.datosTestamento.vitalTestament !== "" ? (
        <Col lg="6" className="border">
          <h6>Testamento Vital</h6>
          <a href={process.env.REACT_APP_API_URL + "/download/hermanas/" + this.props.DatosMonja.sister.id + "/testamentoVital"} target="_blank" rel="noreferrer">
            PDF Testamento Vital
          </a>
        </Col>
      ) : (
        <Col lg="6" className="border">
          <h6>PDF Testamento Vital</h6>
          <p>Testamento no adjuntado</p>
        </Col>
      );

    const DesplegableAdministrador =
      this.props.DatosMonja.datosTestamento && this.props.DatosMonja.datosTestamento.nameAdministrator ? (
        <Desplegable
          Toogle={"Datos Administrador"}
          Text={
            <Col>
              <Row>
                <Col lg="4" className="border">
                  <h6>Nombre del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.nameAdministrator}</p>
                </Col>

                <Col lg="4" className="border">
                  <h6>Apellidos del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.surnameAdministrator}</p>
                </Col>

                <Col lg="4" className="border">
                  <h6>Parentesco del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.relationshipAdministrator}</p>
                </Col>
              </Row>
              <Row>
                <Col lg="4" className="border">
                  <h6>País del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.countryAdministrator}</p>
                </Col>

                <Col lg="4" className="border">
                  <h6>Provincia del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.provinceAdministrator}</p>
                </Col>

                <Col lg="4" className="border">
                  <h6>Dirección del Administrador</h6>
                  <p>{this.props.DatosMonja.datosTestamento.addressAdministrator}</p>
                </Col>
              </Row>
            </Col>
          }
        />
      ) : (
        <Col className="border">
          <h6>Datos Administrador</h6>
          <p>No especificados</p>
        </Col>
      );

    return (
      <React.Fragment>
        <Container className="mb-3">
          <Row>
            {testamentoBienes}
            {testamentoVital}
          </Row>
        </Container>
        {DesplegableAdministrador}
      </React.Fragment>
    );
  }
}
